// TODO: change thumbnail
import { useEffect, useState } from 'react';
import {
  Link
} from 'react-router-dom';

const CardItem = (props) => {
  const [img, setImg] = useState(props?.data?.card_image_url);

  useEffect(() => {
    // correct some of GT's errors.
    const imgUrl = props?.data?.card_image_url;
    const imgUrlArray = imgUrl.split('.');
    if (imgUrlArray[imgUrlArray.length - 1] === 'pngg') {
      setImg(imgUrl.slice(0, imgUrl.length - 1));
    }
  }, [])

  return (
    <div
      style={{
        width: '33.333333%',
        height: 'auto',
        borderRadius: '0',
        overflow: 'hidden',
        boxSizing: 'border-box',
        margin: '5px',
        cursor: 'pointer',
        position: 'relative'
      }}
    >
      <Link
        to={'card/' + props?.data?.code}
        style={{

        }}
      >
        <img
          src={img || 'https://crm.globetopper.com/brandImages/61086a9b755fc.png'}
          className="img-fluid"
          alt=""
          style={{aspectRatio: '16/10', width: '100%', scale: '110%'}}
        />
        <div
          style={{
            position: 'absolute',
            top: '5%',
            right: '5%',
            borderRadius: '30px',
            backgroundColor: '#ffcd04',
            padding: '0 10px',
            color: 'black',
            fontSize: '2.5vw'
          }}
        >
          {props?.data?.denomination_type === 'open' ? (
            `from ${+(props?.data?.minimum_value)} ${props?.data?.currency_code}`
          ) : (
            `${+(props?.data?.minimum_value)} ${props?.data?.currency_code}`
          )}
        </div>
        <span
          style={{
            position: 'absolute',
            bottom: '5%',
            left: '5%',
            borderRadius: '50%',
            width: '15%',
            height: 0,
            paddingBottom: '15%',
            boxSizing: 'content-box'
          }}
          className={`fi fi-${props?.data?.countries[0]?.toLowerCase()} fis`}></span>
      </Link>
    </div>
  );
};

export default CardItem;
